<template>
  <div class="hello">
     <div class="box"></div>
     <router-link to="/badge">help</router-link>
     <button @click="test">66666</button>
     <!-- <router-view></router-view> -->
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted(){
    console.log(process.env);
  },
  methods: {
    test(){
       console.log(88888);
    }
  },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .box{
    width: 3.75rem;
    height: 1rem;
    background: blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue